import { ICellRendererParams } from "ag-grid-community";
import { useState } from "react";
import { createNegativeKeywords, cellSpinnerHandler } from "@ts/utils";
import { showToast } from "@ts/modals";
import * as Sentry from "@sentry/react";
import { isTarget } from "@ts/bulk-keywords-addition";
import { FaPlus } from "react-icons/fa";
import { usePermissionCheck } from "@/hooks/AllCustomHooks";

const AddNegativeButtonRenderer = (params: ICellRendererParams) => {
    const [identifier] = useState(params.data.id);
    const [disabled, setDisabled] = useState(false);
    const { campaign_id, ad_group_id, customer_search_term, program_type } =
        params.data;
    const [loading, setLoading] = useState<boolean>(false);
    const { isModuleEditDisabled } = usePermissionCheck({ type: "cellRenderer" });

    const negativeButtonHandler = async () => {
        try {
            const checkIfTarget = isTarget(customer_search_term);
            const negativeKeywordsData = [
                {
                    campaignId: campaign_id,
                    ...(ad_group_id && { adGroupId: ad_group_id }),
                    keywordText: customer_search_term,
                    programType: program_type,
                    matchType: checkIfTarget ? "asinSameAs" : "negativeExact",
                    state: "enabled",
                    attribute: ["create_negative_target"]
                },
            ];

            const data = checkIfTarget
                ? { targets: negativeKeywordsData }
                : { keywords: negativeKeywordsData };

            const response = await createNegativeKeywords(data);
            setDisabled(true);
            if (!response.status) {
                throw new Error(response.message);
            }
            showToast("success", response.message);
        } catch (err) {
            console.error(err);
            showToast(
                "danger",
                `Unable to create negative keyword ${params.data.customer_search_term
                }: ${(err as Error).message}`
            );
            Sentry.captureException(err);
        } finally {
            setDisabled(false);
        }
    };
    return (
        <>
            {params.node.rowPinned ? null : (
                <button
                    className="btn btn-sm btn-danger"
                    id={`add_as_negative_button_${identifier}`}
                    onClick={() => cellSpinnerHandler(setLoading, negativeButtonHandler)}
                    disabled={disabled || loading || isModuleEditDisabled}
                >
                    {loading ? (
                        <i
                            className="spinner-border"
                            style={{ width: "1em", height: "1em" }}
                        />
                    ) : (
                        <FaPlus style={{ transform: "translateY(-10%)" }} />
                    )}
                </button>
            )}
        </>
    );
};

export default AddNegativeButtonRenderer;
